module.exports = __webpack_public_path__ + "assets/normal/images/language.0f657668.png";